//Claves satelite: valores que un metadato escribe en jsonmetx ademas de la suya propia.
//Al cambiar o limpiar el metadato dueño, sus satelites dejan de tener sentido.
export const SATELLITE_KEYS = {
  DIRECPRO: ["CLIPROCB", "APLVECIX", "PIEIDXXX", "PAIIDXXX", "DEPIDXXX", "CIUIDXXX"],
  CLIIDXXX: ["CATIDXXX"],
  TRANINTX: ["TRABANVE", "ODIIDXXX"],
  PROIDXXX: ["CAPDAFAC"],
};

//Metadatos que se consultan filtrando por el valor de OTRO metadato, identificados por la
//funcion configurada en METOPXXX. Si el padre cambia, el hijo quedo resuelto contra un
//filtro que ya no existe: sus opciones son otras y el valor anterior no es valido.
export const DEPENDENCIES_BY_FUNCTION = {
  getDireccionProveedor: () => ["CLIIDXXX", "PROIDXXX"],
  getNumContrato: () => ["CLIIDXXX", "PROIDXXX"],
  getReferencia: () => ["CLIIDXXX"],
  getDo: () => ["CLIIDXXX"],
  f_getController: () => ["CLIIDXXX", "USERDIFE"],
  getFactura: () => ["NUMPEDXX"],
  getProvider: ({ company, area }) =>
    company === "800251957" || area === "100" || area === "101" ? ["CLIIDXXX"] : [],
};

//Dependencias que no se pueden deducir de METOPXXX porque el metadato se resuelve por su id
export const DEPENDENCIES_BY_METADATA = {
  //DIRECPRO tipo LISTASELECCION se consulta desde Metadata con CLIIDXXX + PROIDXXX
  DIRECPRO: ["CLIIDXXX", "PROIDXXX"],
  //NUMANIFI se autocompleta a partir del comprobante en los tipos 619 y 674
  NUMANIFI: ["NUMCOMPR"],
};

//Una consulta parametrizada por otro metadato no se puede cachear por texto de busqueda:
//el mismo texto con otro cliente o proveedor debe traer resultados distintos.
export const dependsOnOtherMetadata = (METOPXXX) =>
  Object.prototype.hasOwnProperty.call(DEPENDENCIES_BY_FUNCTION, METOPXXX);
